// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  ISuggestRealtorFormRequest,
  TSuggestRealtorFormModel,
  IMappers,
  TSuggestRealtorFormResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISuggestRealtorFormResponse } from '../../entities/entities/SuggestRealtorFormResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSuggestRealtorFormModel(parameters: ISuggestRealtorFormRequest): TSuggestRealtorFormModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-suggest',
    pathApi: '/v1/suggest-realtor-form/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ISuggestRealtorFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISuggestRealtorFormRequest;
}

export async function fetchSuggestRealtorForm<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISuggestRealtorFormOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSuggestRealtorFormResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSuggestRealtorFormModel(parameters),
    config,
  )) as FetchResponse<TSuggestRealtorFormResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISuggestRealtorFormResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSuggestRealtorFormResponse>;
}
